// L6 tramo 1 (fix) · Resuelve el NOMBRE y el RUT de un negocio de cartelería SEGÚN SU TIPO — nunca por
// `referencia_id` a ciegas (10.7). `referencia_id` (text) apunta a `clientes` cuando el negocio es venta
// directa (`tipo_vertical='TD'`) o a `edificios` cuando es de edificio (`EO`/`OT`), y los ids COLISIONAN
// entre las dos tablas: negocio 11 (EO, ref 156) → edificio "De La Industria", pero cliente 156 = "SANITAS".
// Mirar `clientes` sin conocer el tipo mostraba "SANITAS · Gestión". Misma prioridad que el loader de la
// grilla (`useVFDataLoading`): TD → cliente primero; resto → edificio primero, cliente como fallback (caso
// OT tipo huérfano). El RUT solo existe cuando la referencia es un CLIENTE (edificios no tiene RUT) → un
// negocio de edificio no aporta RUT para ordenar (sin error). Función PURA (recibe los mapas ya cargados).

const leer = (mapa, k) => (mapa instanceof Map ? mapa.get(k) : mapa?.[k]) ?? null;

/**
 * @param {{tipo_vertical?:string, referencia_id?:(string|number), nombre_proyecto?:string}} negocio
 * @param {{clientesById?:(Map|Object), edificiosById?:(Map|Object)}} maps  id(text) → {nombre,rut} / {edificio}
 * @returns {{nombre:(string|null), rut:(string|null)}}
 */
export const resolverNombreRutNegocio = (negocio, { clientesById, edificiosById } = {}) => {
  const ref = negocio?.referencia_id != null ? String(negocio.referencia_id) : null;
  const cl = ref != null ? leer(clientesById, ref) : null;
  const ed = ref != null ? leer(edificiosById, ref) : null;

  let nombre = null;
  let rut = null;
  if (negocio?.tipo_vertical === "TD") {
    if (cl) {
      nombre = cl.nombre;
      rut = cl.rut ?? null;
    } else if (ed) {
      nombre = ed.edificio;
    }
  } else {
    // EO / OT: edificio primero; cliente como fallback. RUT solo si la referencia resultó ser un cliente.
    if (ed) {
      nombre = ed.edificio;
    } else if (cl) {
      nombre = cl.nombre;
      rut = cl.rut ?? null;
    }
  }
  nombre = nombre || negocio?.nombre_proyecto || null;
  return { nombre, rut };
};
